module.exports = __webpack_public_path__ + "img/debt-cover-bigger.3925631d.png";